<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/picker" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">选择器</div>

        <div class="sub-title">单列不联动</div>
        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">多列不联动</div>
        <pre v-highlightjs="code3"><code class="html" ></code></pre>
        <pre v-highlightjs="code4"><code class="javascript" ></code></pre>

        <div class="sub-title">多列联动</div>
        <pre v-highlightjs="code5"><code class="html" ></code></pre>
        <pre v-highlightjs="code6"><code class="javascript" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-picker :options="pickerOptions"/>
      `,
      code2: `
  import { YuPicker } from 'yu.mobile';

  export default {
    name: 'checkbox',
    data() {
      return {
        pickerOptions: [
          [
            { value: 0, label: '博士' },
            { value: 1, label: '本科' },
            { value: 2, label: '高中' },
          ],
        ],
       }
    },
    components: {
      YuPicker,
    },
  };
      `,
      code3: `
  <yu-picker :options="pickerOptions" :cols="3"/>
      `,
      code4: `
  import { YuPicker } from 'yu.mobile';

  export default {
    name: 'checkbox',
    data() {
      return {
        pickerOptions: [
          [
            { value: 0, label: '博士' },
            { value: 1, label: '本科' },
            { value: 2, label: '高中' },
          ],
          [
            { value: 0, label: '博士' },
            { value: 1, label: '本科' },
            { value: 2, label: '高中' },
          ],
          [
            { value: 0, label: '博士' },
            { value: 1, label: '本科' },
            { value: 2, label: '高中' },
          ],
        ],
       }
    },
    components: {
      YuPicker,
    },
  };
      `,
      code5: `
  <yu-picker title="输入地址"
             :options="cascaderOptions"
             :cols="3"
             type="cascader"/>
      `,
      code6: `
  import { YuPicker } from 'yu.mobile';

export default {
  name: 'checkbox',
  data() {
    return {
      cascaderOptions: [
        {
          label: '浙江',
          value: '1',
          children: [
            {
              label: '杭州',
              value: '11',
              children: [{ label: '滨江', value: '111' }],
            },
          ],
        },
        {
          label: '山东',
          value: '2',
          children: [
            {
              label: '济南',
              value: '22',
              children: [{ label: '小区', value: '222' }],
            },
          ],
        },
        {
          label: '福建',
          value: '3',
          children: [
            {
              label: '厦门',
              value: '33',
              children: [{ label: '思明', value: '333' }],
            },
          ],
        },
      ],
    }
  },
  components: {
    YuPicker,
  },
};
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'placeholder',
          description: '提示语',
          types: 'String',
          default: '请选择',
        },
        {
          prop: 'options',
          description: '选项 不联动 [[],...], 联动 [{},...]',
          types: 'Array',
          default: '无',
        },
        {
          prop: 'cols',
          description: '显示列数，[1,2,3]',
          types: 'Number',
          default: '无',
        },
        {
          prop: 'type',
          description: '是否联动[select,cascader]',
          types: 'String',
          default: 'select',
        },
        {
          prop: 'title',
          description: '标题',
          types: 'String',
          default: '无',
        },
        {
          prop: 'remote',
          description: '是否远程加载联动选项',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'split',
          description: '分隔符号',
          types: 'String',
          default: '/',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'firstFetch',
          description: '（远程加载）联动选项时第一列被选择时触发,返回被选择项',
          callback: '( select: Object )',
        },
        {
          event: 'secondFetch',
          description: '（远程加载）联动选项时第二列被选择时触发,返回被选择项',
          callback: '( select: Object )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/picker.vue